import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRREP_RPT;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
